import useSubmitButtonName from 'hooks/forms/useSubmitButtonName';
import useSubmit from 'hooks/forms/useSubmitForm';
import { message } from 'antd';
import I18n from 'i18n-js';
import buildFormParams from '../helpers/buildFormParams';

const useSubmitForm = ({
  id,
  form,
  formUrl,
  clearErrors,
  handleError,
  setIsModalOpen,
  setInitialTickets,
  ticketFromDashboard,
  attachments,
  setAttachments,
}) => {
  const { handleSubmitForm, isFormSending } = useSubmit({
    formUrl,
    handleError,
    objectId: id,
    beforeSubmitForm: clearErrors,
    buildFormParams: () => (buildFormParams({ form, attachments })),
    afterSuccessSubmitForm: ({ data }) => {
      form.resetFields();
      setAttachments([]);
      setIsModalOpen(false);

      if (ticketFromDashboard) {
        setInitialTickets(data.filteredTickets);
      } else {
        globalThis.location.href = data.redirectUrl;
      }

      message.success(I18n.t(id ? 'flash.tickets.updated' : 'flash.tickets.created'));
    },
  });

  const handleSubmitWrapper = (formData) => {
    clearErrors();
    handleSubmitForm(formData);
  };

  const submitButtonName = useSubmitButtonName({
    objectId: id,
    isFormSending,
    modelName: 'ticket',
  });

  return {
    isFormSending,
    submitButtonName,
    handleSubmitForm: handleSubmitWrapper,
  };
};

export default useSubmitForm;
